'use client';

import { useIntl } from 'react-intl';
import { type DemoOrgAccessCookieValue, roleLabelId } from '@/util/demoOrgSession';

/** Keeps useIntl out of the parent so the non-demo path needs no IntlProvider. */
const DemoOrgTitle = ({ orgName, role }: Pick<DemoOrgAccessCookieValue, 'orgName' | 'role'>) => {
  const intl = useIntl();
  return intl.formatMessage({ id: 'admin.demo-orgs.banner.viewing-as' }, { orgName, role: intl.formatMessage({ id: roleLabelId(role) }) });
};

export default DemoOrgTitle;
